import React, { useState } from "react";
import { Turnstile } from "@marsidev/react-turnstile";
import { useTranslation } from "react-i18next";
import { Spinner } from "./ui/Spinner";
import { AlertCircle } from "lucide-react";
export const TurnstileValidator = ({ siteKey, onSuccess, onError }) => {
  const { t } = useTranslation();
  const [isVerifying, setIsVerifying] = useState(false);
  const [error, setError] = useState(null);

  const handleSuccess = async (token) => {
    setIsVerifying(true);
    setError(null);

    try {
      await onSuccess(token);
    } catch (err) {
      console.error('Turnstile validation error:', err);
      setError(t("turnstile.error"));
      onError?.(err);
    } finally {
      setIsVerifying(false);
    }
  };

  const handleError = (error) => {
    console.error('Turnstile widget error:', error);
    setError(t("turnstile.error"));
    onError?.(new Error(t("turnstile.error")));
  };

  return (
    <div className="gpc-validator-container">
      <div className="gpc-validator-header">
        <h3 className="gpc-validator-title">{t("chat.validation")}</h3>
        <p className="gpc-validator-subtitle">{t("turnstile.verifying")}</p>
      </div>

      {!error && (
        <div className="gpc-animate-fade-in">
          <Turnstile
            siteKey={siteKey}
            onSuccess={handleSuccess}
            onError={handleError}
            options={{
              theme: "light",
              size: "normal",
            }}
          />
        </div>
      )}

      {isVerifying && (
        <div className="gpc-validator-loading">
          <Spinner size="md" />
          <p className="gpc-validator-text">{t("chat.validation")}</p>
        </div>
      )}

      {error && (
        <div className="gpc-validator-error">
          <AlertCircle className="gpc-error-icon" />
          <div className="gpc-error-content">
            <p className="gpc-error-title">{t("errors.validation")}</p>
            <p className="gpc-error-message">{error}</p>
            <button
              onClick={() => window.location.reload()}
              className="gpc-error-button"
            >
              {t("chat.retry")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};